/**
 * Event style constants for all calendar event types.
 * Matches the design system colors used in the old KInterviewScheduler.
 */

export const EVENT_STYLES = {
  booked: {
    backgroundColor: 'var(--kula-colors-primary-500)',
    borderColor: 'var(--kula-colors-primary-600)',
    textColor: '#ffffff',
  },
  bookedError: {
    backgroundColor: 'var(--kula-colors-error-200)',
    borderColor: 'var(--kula-colors-error-200)',
    textColor: '#ffffff',
  },
  busy: {
    backgroundColor: 'var(--kula-colors-secondary-100)',
    borderColor: 'var(--kula-colors-secondary-200)',
    textColor: 'var(--kula-colors-secondary-600)',
  },
  available: {
    backgroundColor: 'var(--kula-colors-pastel-1-light)',
    borderColor: 'var(--kula-colors-pastel-1)',
    textColor: 'var(--kula-colors-pastel-1-dark)',
  },
  candidateAvailMutual: {
    backgroundColor: 'var(--kula-colors-pastel-2-light)',
    borderColor: 'var(--kula-colors-pastel-2)',
    textColor: 'var(--kula-colors-pastel-2-dark)',
  },
  candidateAvailNoMutual: {
    backgroundColor: 'var(--kula-colors-pastel-2-light)',
    borderColor: 'var(--kula-colors-pastel-2)',
    textColor: 'var(--kula-colors-pastel-2-dark)',
  },
  meetingRoom: {
    // pastel-5 is the muted purple-grey family in the design system —
    // sits visually beneath interviewer pastels so it reads as
    // "resource" rather than "person" (legacy parity with
    // rgb(211, 211, 233) / rgb(147, 145, 162)).
    backgroundColor: 'var(--kula-colors-pastel-5-light)',
    borderColor: 'var(--kula-colors-pastel-5-light)',
    textColor: 'var(--kula-colors-pastel-5-dark)',
  },
} as const;

/**
 * Event render priority — higher value renders ON TOP.
 *
 * Consumed by FullCalendar's `eventOrder="extendedProps.priority,..."`
 * (ASCENDING — no leading `-`). FC gives the seg that sorts LAST the
 * deepest stackDepth, hence the highest z-index, so higher priority must
 * come later in the sort → ascending order. Keep both calendars'
 * `eventOrder` ascending; a leading `-` buries booked behind busy.
 */
export const EVENT_PRIORITY = {
  booked: 20,
  busy: 10,
  available: 5,
  candidateAvailability: 3,
  meetingRoom: 2,
  background: 0,
} as const;

/** Event category keys used in extendedProps.category */
export type EventCategory =
  | 'booked'
  | 'busy'
  | 'available'
  | 'candidate-availability'
  | 'meeting_room'
  | 'external'
  | 'background';

/** CSS class names for background events */
export const BG_EVENT_CLASSES = {
  disabledSlots: 'bg-disabled-slots',
  unavailableHours: 'bg-unavailable-working-hours',
  minimumNotice: 'bg-minimum-notice-disabled-slots',
  slotBuffer: 'bg-slot-buffer',
} as const;
